<!-- Copyright (c) 2023 VMware, Inc. All rights reserved. VMware Confidential -->
<div class="alert alert-app-level alert-danger" role="alert"
     *ngIf="errorMsg && errorMsg.length > 0">
    <div class="alert-items">
        <div class="alert-item static">
            <div class="alert-icon-wrapper">
                <cds-icon class="alert-icon"
                          shape="exclamation-circle"
                          [attr.aria-hidden]="true"></cds-icon>
            </div>
            <div class="alert-text">
                {{ errorMsg }}
            </div>
            <div *ngIf="!!errorBtn"
                 class="alert-actions">
                <button class="btn alert-action"
                        (click)="onErrorButtonClick()">
                    {{ errorBtn }}
                </button>
            </div>
        </div>
    </div>
    <button *ngIf="closable" type="button" class="close" aria-label="Close">
        <cds-icon shape="close"
                  [attr.aria-hidden]="true"></cds-icon>
    </button>
</div>
